module.exports = __webpack_public_path__ + "img/ic_bath.e0063d6b.svg";